;(function() {
  'use strict'

  angular.module('app.survey').component('surveyGenerator', {
    controller: Controller,
    templateUrl: 'survey-generator.html',
    bindings: {
      survey: '<',
      onDone: '&',
      onCancel: '&',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.cancel = cancel
    ctrl.done = done
    ctrl.reset = reset
    ctrl.$onInit = onInit

    function onInit() {
      ctrl.amount = ctrl.survey.generatorAmount
      ctrl.parallel = ctrl.survey.generatorParallel
    }

    function cancel() {
      ctrl.onCancel()
    }

    function done() {
      ctrl.survey.generatorAmount = ctrl.amount
      ctrl.survey.generatorParallel = ctrl.parallel
      ctrl.onDone()
    }

    function reset() {
      ctrl.survey.generatorAmount = 1
      ctrl.survey.generatorParallel = 1
      ctrl.onDone()
    }
  }
})()
